import { useSelector } from 'react-redux';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { saveQuoteSchema } from 'validation/form/marketplace';
import { saveQuote } from 'store/slices/marketplace';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';

export const SaveQuote = (props) => {
  const { close } = props;

  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const loading = useSelector((state) => state.marketplace.saveQuoteForm.loading);
  const selectedQuote = useSelector((state) => state.marketplace.selectedQuote);

  const methods = useForm({
    resolver: yupResolver(saveQuoteSchema),
    defaultValues: {
      name: '',
    },
  });

  const handleSave = methods.handleSubmit((data) => {
    dispatchAction(saveQuote({ quoteId: selectedQuote?.id, form: data }), {
      onSuccess: () => {
        enqueueSnackbar('Quote has been saved');
        close();
      },
    });
  });

  return (
    <DrawerContent>
      <DrawerContent.Header title="Save Quote" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormTextField
              name="name"
              label="Quote Name"
              control={methods.control}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Save"
          submitButtonLoading={loading}
          submit={handleSave}
          close={close}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
